import React from "react";
import { useNavigate } from "react-router-dom";
import { IconCalendarLight } from "../../icon/icons";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/confetti.css";
import "./dashboard.scss";
import {
  AllProject,
  Calender,
  InfoBoxs,
  RecentProject,
  Revenue,
  TitleHeader,
} from "../../components";
import RecentCustomers from "../../components/maindashboard/recencustomers";
import useDashboardUtils from "./dashboardUtils";

const MainDashboard = () => {
  const navigate = useNavigate();

  const {
    listData,
    loading,
    currentPage,
    limit,
    fetchDashboardData,
    handleSearch,
    handleFilter,
    handlePageChange,
  } = useDashboardUtils();

  return (
    <>
      <div className="main-dashboard-header-top">
        <div className="flex-data-main">
          <div className="header-top-data">
            <TitleHeader
              heading="Welcome to Jayeek!"
              buttonText=""
              onButtonClick={""}
            />
          </div>
        </div>
        

        <InfoBoxs listData = {listData} />

        <div className="layout-main-dashboard">
          <div className="row">
            <div className="col-md-6">
              <RecentProject  latestOrders = {listData?.latestOrders || []} />
            </div>
            <div className="col-md-6">
              <RecentCustomers recentCustomers = {listData?.recentCustomers || []} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
